import './Dialog.css.proxy.js';
/* src/components/popup/Dialog.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	stop_propagation,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { onMount } from "../../web_modules/svelte.js";
import Cookies from "../../web_modules/js-cookie.js";
import { Popup } from "../../_modules/popup/index.js";
import Wrap from "../slot/Wrap.js";

function create_if_block(ctx) {
	let div;
	let wrap;
	let current;
	let mounted;
	let dispose;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(wrap.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(wrap.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "dialog svelte-o8mj0i");
			toggle_class(div, "show", /*show*/ ctx[2]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(wrap, div, null);
			current = true;

			if (!mounted) {
				dispose = listen(div, "click", /*hide*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, popup*/ 65) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);

			if (dirty & /*show*/ 4) {
				toggle_class(div, "show", /*show*/ ctx[2]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(wrap);
			mounted = false;
			dispose();
		}
	};
}

// (35:69) <Wrap>
function create_default_slot(ctx) {
	let div;
	let button;
	let t;
	let img;
	let img_src_value;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			button = element("button");
			t = text("×");
			img = element("img");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			button = claim_element(div_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, "×");
			button_nodes.forEach(detach);
			img = claim_element(div_nodes, "IMG", { src: true, alt: true, class: true });
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "class", "svelte-o8mj0i");
			if (img.src !== (img_src_value = /*popup*/ ctx[0].featuredImage.getSized("large"))) attr(img, "src", img_src_value);
			attr(img, "alt", "お知らせを上手く読み込めませんでした");
			attr(img, "class", "svelte-o8mj0i");
			attr(div, "class", "contents svelte-o8mj0i");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button);
			append(button, t);
			append(div, img);

			if (!mounted) {
				dispose = [
					listen(button, "click", /*hide*/ ctx[3]),
					listen(img, "click", stop_propagation(click_handler))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*popup*/ 1 && img.src !== (img_src_value = /*popup*/ ctx[0].featuredImage.getSized("large"))) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*valid*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*valid*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*valid*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

const threshold = 150;

const click_handler = () => {
	
};

function instance($$self, $$props, $$invalidate) {
	let { popup } = $$props;
	let valid = false;
	let show = false;
	let timer = null;

	onMount(() => {
		if (Cookies.get("popup") === popup.id) return;
		$$invalidate(1, valid = true);
		window.addEventListener("scroll", scrollHandler, false);
		Cookies.set("popup", popup.id, { expires: 1 });
	});

	function hide() {
		$$invalidate(2, show = false);
		window.removeEventListener("scroll", scrollHandler, false);
	}

	function scrollHandler() {
		if (timer !== null) return;

		timer = setTimeout(
			() => {
				if (window.scrollY > threshold) {
					$$invalidate(2, show = true);
					timer = 0;
					return;
				}

				timer = null;
			},
			500
		);
	}

	$$self.$$set = $$props => {
		if ("popup" in $$props) $$invalidate(0, popup = $$props.popup);
	};

	return [popup, valid, show, hide];
}

class Dialog extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { popup: 0 });
	}
}

export default Dialog;
//# sourceMappingURL=Dialog.js.map
